import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { useAuth, homePath } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { ErrorBox, Field } from "@/components/common";

const IMG = "https://images.unsplash.com/photo-1761205002197-2bdb71785f7b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.must_change_password ? "/change-password" : homePath(user)} replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const u = await login(f.username, f.password);
      nav(u.must_change_password ? "/change-password" : homePath(u), { replace: true });
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="حظيرة الأغنام" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1A4D2E]/70" />
        <div className="relative h-full flex flex-col justify-end p-14 text-white">
          <div className="w-16 h-16 rounded-2xl bg-[#D97706] grid place-items-center font-black text-3xl font-display mb-6">ر</div>
          <h1 className="text-5xl font-black font-display">الربيع للأضاحي</h1>
          <p className="mt-3 text-lg text-emerald-50/90 max-w-md">من البطاقة الزرقاء إلى بوابة الخروج: بيع، تسديد، تسليم وخروج موثّق لكل كبش.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md space-y-5 fade-up" data-testid="login-form">
          <div className="lg:hidden w-14 h-14 rounded-2xl bg-[#1A4D2E] text-white grid place-items-center font-black text-2xl font-display">ر</div>
          <div>
            <h2 className="text-3xl font-extrabold text-[#1A4D2E]">تسجيل الدخول</h2>
            <p className="text-slate-500 mt-1">الحسابات تُنشأ من طرف المدير فقط</p>
          </div>
          <Field label="اسم المستخدم أو البريد الإلكتروني">
            <input className="k-input" autoComplete="username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} data-testid="login-username-input" required />
          </Field>
          <Field label="كلمة المرور">
            <input className="k-input" type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password-input" required />
          </Field>
          <ErrorBox text={err} />
          <button className="k-btn-primary w-full h-14 text-lg" disabled={busy} data-testid="login-submit-button">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <LogIn className="w-5 h-5" />} دخول
          </button>
        </form>
      </div>
    </div>
  );
}
